import React from "react"
import Loader from "../Components/BifrostPageComponent/Loader/Loader"
import MainPanel from "./MainPanel/MainPanel"
import Sidebar from "./Sidebar/Sidebar"

const Pages = ({ isLoadingForGetUserInfo, isLoadingForAuth }) => {
	return isLoadingForAuth || isLoadingForGetUserInfo ? (
		<div style={{ height: "100vh" }}>
			<Loader />
		</div>
	) : (
		<div id="global-wrapper">
			<Sidebar isLoadingForGetUserInfo={isLoadingForGetUserInfo} />
			<MainPanel />
		</div>
	)
}

export default Pages
